import {
  ADD_SCALE_FAIL,
  ADD_SCALE_REQUEST,
  ADD_SCALE_SUCCESS,
  DELETE_SCALE_FAIL,
  DELETE_SCALE_REQUEST,
  DELETE_SCALE_SUCCESS,
  GET_SCALE_LIST_FAIL,
  GET_SCALE_LIST_REQUEST,
  GET_SCALE_LIST_SUCCESS,
  GET_SINGLE_SCALE_FAIL,
  GET_SINGLE_SCALE_REQUEST,
  GET_SINGLE_SCALE_SUCCESS,
  UPDATE_SCALE_FAIL,
  UPDATE_SCALE_REQUEST,
  UPDATE_SCALE_SUCCESS,
  UPDATE_SCALE2_FAIL,
  UPDATE_SCALE2_REQUEST,
  UPDATE_SCALE2_SUCCESS,
  UPDATE_SENDER_WAREHOUSE_CONFIG_FAIL,
  UPDATE_SENDER_WAREHOUSE_CONFIG_SUCCESS,
  UPDATE_SENDER_WAREHOUSE_CONFIG_REQUEST,
  GET_SENDER_WAREHOUSE_CONFIG_FAIL,
  GET_SENDER_WAREHOUSE_CONFIG_SUCCESS,
  GET_SENDER_WAREHOUSE_CONFIG_REQUEST,
  ADD_SENDER_WAREHOUSE_CONFIG_FAIL,
  ADD_SENDER_WAREHOUSE_CONFIG_SUCCESS,
  ADD_SENDER_WAREHOUSE_CONFIG_REQUEST,
  DELETE_SENDER_WAREHOUSE_CONFIG_FAIL,
  DELETE_SENDER_WAREHOUSE_CONFIG_SUCCESS,
  DELETE_SENDER_WAREHOUSE_CONFIG_REQUEST,
  GET_SENDER_WAREHOUSE_CONFIG_LIST_FAIL,
  GET_SENDER_WAREHOUSE_CONFIG_LIST_SUCCESS,
  GET_SENDER_WAREHOUSE_CONFIG_LIST_REQUEST,
} from "src/constants/types";

export const scalesReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_SCALE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SCALE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        scaleList: actions.payload,
        error: "",
      };
    case GET_SCALE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_SCALE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_SCALE_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_scale: actions.payload,
      };
    case GET_SINGLE_SCALE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_SCALE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SCALE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_SCALE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_SCALE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SCALE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_SCALE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_SCALE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_SCALE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_SCALE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_SCALE2_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_SCALE2_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_SCALE2_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SENDER_WAREHOUSE_CONFIG_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SENDER_WAREHOUSE_CONFIG_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        senderWarehouseConfigList: actions.payload,
        error: "",
      };
    case GET_SENDER_WAREHOUSE_CONFIG_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_SENDER_WAREHOUSE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SENDER_WAREHOUSE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_SENDER_WAREHOUSE_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_SENDER_WAREHOUSE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SENDER_WAREHOUSE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_SENDER_WAREHOUSE_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SENDER_WAREHOUSE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SENDER_WAREHOUSE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        senderWarehouseConfig: actions.payload,
      };
    case GET_SENDER_WAREHOUSE_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_SENDER_WAREHOUSE_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_SENDER_WAREHOUSE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_SENDER_WAREHOUSE_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
